import { alertsActions } from '.';
import getErrorMessage from 'utils/getErrorMessage';
import { countriesConstants } from 'store/constants';
import { countriesServices } from 'store/services/countries.service';

const loadCountries = () => {
  const request = () => ({
    type: countriesConstants.COUNTRIES_REQUEST,
  });
  const success = (countries) => ({
    type: countriesConstants.COUNTRIES_SUCCESS,
    payload: {
      countries,
    },
  });
  const failure = (error) => ({
    type: countriesConstants.COUNTRIES_ERROR,
    payload: {
      error,
    },
  });
  return async (dispatch) => {
    dispatch(request());
    try {
      const data = await countriesServices.loadCountries();
      dispatch(success(data));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch(failure(errorMessage as string));
      dispatch(alertsActions.error(errorMessage));
    }
  };
};

export const countriesActions = {
  loadCountries,
};
